import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { customHeaders, programManagementURL } from '../../../../../Containers/Config/index.js';
import apiCall from '../../../apiCall.js';
import { UPDATE_PROGRAM_DATA, UPDATE_PROGRAM_DATA_ERROR, UPDATE_PROGRAM_DATA_SUCCESS } from '../../../actionType.js';
import cogoToast from 'cogo-toast';

function* updateProgramData({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${programManagementURL}/api/v1/program/${payload?.params?.id}/${payload?.params?.section}`,
      method: 'PATCH',
      headers: {
        ...filteredHeaders,
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      yield put({
        type: UPDATE_PROGRAM_DATA_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: UPDATE_PROGRAM_DATA_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: UPDATE_PROGRAM_DATA_ERROR, payload: error });
  }
}

export function* watchUpdateProgramData() {
  yield takeEvery(UPDATE_PROGRAM_DATA, updateProgramData);
}

function* getUpdateProgramDataSaga() {
  yield all([fork(watchUpdateProgramData)]);
}

export default getUpdateProgramDataSaga;
